import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "./views/Login/Login";
import NotFound from "./views/NotFound";
import DefaultLayout from "./layouts/DefaultLayout/DefaultLayout";
import GuestLayout from "./layouts/GuestLayout/GuestLayout";
import Dashboard from "./views/Dashboard";
import Space from "./views/Spaces/Space";
import Spaces from "./views/Spaces/Spaces";
import Maps from "./views/Maps/Maps";
import Map from "./views/Maps/Map";
import Labels from "./views/Labels";
import Label from "./views/Label";
import FeedbackQuestions from "./views/FeedbackQuestions";
import FeedbackQuestion from "./views/FeedbackQuestion";
import InfoPages from "./views/InfoPages";
import InfoPage from "./views/InfoPage";
import TreasureHunt from "./views/TreasureHunt";
import TreasureClue from "./views/TreasureClue";
import ModelsPage from "./views/ModelsPage";
import ModelPage from "./views/ModelPage";
import SelfieMasks from "./views/SelfieMasks";
import SelfieMask from "./views/SelfieMask";
import Users from "./views/Users/Users";
import MyAccount from "./views/User/MyAccount";
import ForgotPassword from "./views/ForgotPassword/ForgotPassword";
import ResetPassword from "./views/ResetPassword/ResetPassword";
import Screens from "./views/Screens/Screens";
import Screen from "./views/Screens/Screen";
import Locations from "./views/Locations/Locations";
import Location from "./views/Locations/Location";
import EnvSounds from "./views/EnvSound/EnvSounds";
import EnvSound from "./views/EnvSound/EnvSound";
import { Suspense } from "react";


const router = createBrowserRouter([
    {
        path: '/',
        element: <DefaultLayout />,
        children: [
            {
                path: '/',
                element: <Navigate to={'/spaces'} />
            },
            {
                path: '/dashboard',
                element: <Suspense fallback={<div>Loading Dashboard...</div>}><Dashboard /></Suspense>
            },
            {
                path: '/spaces',
                element: <Suspense fallback={<div>Loading Spaces...</div>}><Spaces /></Suspense>
            }
            ,
            {
                path: '/space/:space_id',
                element: <Suspense fallback={<div>Loading Space...</div>}><Space /></Suspense>
            },
            {
                path: '/maps',
                element: <Suspense fallback={<div>Loading Maps...</div>}><Maps /></Suspense>
            }
            ,
            {
                path: '/map/:map_id',
                element: <Suspense fallback={<div>Loading Map...</div>}><Map /></Suspense>
            },
            {
                path: '/labels',
                element: <Suspense fallback={<div>Loading Labels...</div>}><Labels /></Suspense>
            }
            ,
            {
                path: '/label/:label_id',
                element: <Suspense fallback={<div>Loading Label...</div>}><Label /></Suspense>
            },
            {
                path: '/feedback-question',
                element: <Suspense fallback={<div>Loading Feedback Questions...</div>}><FeedbackQuestions /></Suspense>
            }
            ,
            {
                path: '/feedback-question/:question_id',
                element: <Suspense fallback={<div>Loading Feedback Question...</div>}><FeedbackQuestion /></Suspense>
            },
            {
                path: '/pages',
                element: <Suspense fallback={<div>Loading Info Pages...</div>}><InfoPages /></Suspense>
            },
            {
                path: '/page/:page_id',
                element: <Suspense fallback={<div>Loading Info Page...</div>}><InfoPage /></Suspense>
            },
            {
                path: '/treasure',
                element: <Suspense fallback={<div>Loading Treasure Hunt...</div>}><TreasureHunt /></Suspense>
            },
            {
                path: '/treasure/:clue_id',
                element: <Suspense fallback={<div>Loading Treasure Clue...</div>}><TreasureClue /></Suspense>
            },
            {
                path: '/models',
                element: <Suspense fallback={<div>Loading Models...</div>}><ModelsPage /></Suspense>
            },
            {
                path: '/model',
                element: <Suspense fallback={<div>Loading Model...</div>}><ModelPage /></Suspense>
            },
            {
                path: '/selfie-mask',
                element: <Suspense fallback={<div>Loading Selfie Masks...</div>}><SelfieMasks /></Suspense>
            },
            {
                path: '/selfie-mask/:mask_id',
                element: <Suspense fallback={<div>Loading Selfie Mask...</div>}><SelfieMask /></Suspense>
            },
            {
                path: '/user',
                element: <Suspense fallback={<div>Loading Users...</div>}><Users /></Suspense>
            },
            {
                path: '/my-account',
                element: <Suspense fallback={<div>Loading My Account...</div>}><MyAccount /></Suspense>
            },
            {
                path: '/screen',
                element: <Suspense fallback={<div>Loading Screens...</div>}><Screens /></Suspense>
            },
            {
                path: '/screen/:screen_id',
                element: <Suspense fallback={<div>Loading Screen...</div>}><Screen /></Suspense>
            },
            {
                path: '/locations',
                element: <Suspense fallback={<div>Loading Locations...</div>}><Locations /></Suspense>
            },
            {
                path: '/location/:location_id',
                element: <Suspense fallback={<div>Loading Location...</div>}><Location /></Suspense>
            },
            {
                path: '/env-sounds',
                element: <Suspense fallback={<div>Loading Environment Sounds...</div>}><EnvSounds /></Suspense>
            },
            {
                path: '/env-sound/:env_sound_id',
                element: <Suspense fallback={<div>Loading Environment Sound...</div>}><EnvSound /></Suspense>
            }
        ]
    },
    {
        path: '/',
        element: <GuestLayout />,
        children: [
            {
                path: '/login',
                element: <Suspense fallback={<div>Loading Login...</div>}><Login /></Suspense>
            },
            {
                path: '/forgot-password',
                element: <Suspense fallback={<div>Loading Forgot Password...</div>}><ForgotPassword /></Suspense>
            },
            {
                path: '/reset-password/:token',
                element: <Suspense fallback={<div>Loading Reset Password...</div>}><ResetPassword /></Suspense>
            }
        ]

    },
    {
        path: '*',
        element: <Suspense fallback={<div>Loading Page...</div>}><NotFound /></Suspense>
    }
]);

export default router;